module.exports = __webpack_public_path__ + "img/APSicon3.0aeca21f.png";